import { useContext } from 'react';
import { Table, Tag } from 'antd';
import { ShopOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

import useCityCompanyInvoices from './useCityCompanyInvoices';
import PageHeader from '../../components/PageHeader';
import ActiveFiltersBar from '../../components/ActiveFiltersBar';
import TableCard from '../../components/TableCard';
import TableDicaHint from '../../components/TableDicaHint';
import TablePagination from '../../components/TablePagination';
import { ThemeContext } from '../../contexts/ThemeContext';
import { poeValorComPontosEmMil } from '../../utils/Conversores';

export default function CityCompanyInvoices() {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === 'dark';
    const navigate = useNavigate();

    const {
        columns,
        isLoading,
        tableData,
        handleTableChange,
        handlePaginationChange,
        handleClearAllFilters,
        tableParams,
        totalCompanies,
        activeFilterItems,
    } = useCityCompanyInvoices();

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <PageHeader
                icon={<ShopOutlined />}
                title="Notas Fiscais por Estabelecimento"
                tag={<Tag color="blue">{poeValorComPontosEmMil(totalCompanies || 0)} estabelecimentos</Tag>}
                subtitle="Acompanhe o volume de notas emitidas e valores por estabelecimento comercial cadastrado"
            />

            <ActiveFiltersBar
                filters={activeFilterItems}
                onClearAll={handleClearAllFilters}
            />

            <TableDicaHint text="Na coluna Notas, os valores representam Válidas / Alertas / Erros / Total. Dê um clique na linha para ver todas as notas do estabelecimento." />

            <TablePagination
                current={tableParams.pagination.current}
                pageSize={tableParams.pagination.pageSize}
                total={totalCompanies || 0}
                itemName="estabelecimentos"
                pageSizeOptions={['10', '25', '50', '100']}
                onChange={handlePaginationChange}
            />

            <TableCard>
                <Table
                    rowKey="rowKey"
                    className={`modern-data-table ${isDark ? 'modern-data-table-dark' : ''}`}
                    columns={columns}
                    dataSource={tableData}
                    loading={isLoading}
                    pagination={false}
                    scroll={{ x: 1000 }}
                    onChange={handleTableChange}
                    onRow={(record) => ({
                        onClick: () => {
                            localStorage.removeItem('@NotaMunicipio:allInvoices');
                            navigate('/notas/geral', { state: { company: record.company } });
                        },
                        style: {
                            cursor: 'pointer',
                        },
                    })}
                />
            </TableCard>

            <TablePagination
                current={tableParams.pagination.current}
                pageSize={tableParams.pagination.pageSize}
                total={totalCompanies || 0}
                itemName="estabelecimentos"
                pageSizeOptions={['10', '25', '50', '100']}
                onChange={handlePaginationChange}
            />
        </div>
    );
}
